import React from 'react';
import RevealOnScroll from './RevealOnScroll';

const FinalCTA: React.FC = () => {
   return (
      <section className="py-16 bg-gradient-to-br from-brand-50 to-slate-50 border-t border-slate-200">
         <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <RevealOnScroll>
               <h2 className="text-3xl md:text-4xl font-extrabold text-brand-700 mb-4">
                  Ready to Shop Sri Lanka?
               </h2>
               <p className="text-lg text-slate-600 mb-8">
                  Create your free OTL account and instantly get your own Sri Lankan shipping address. Start shopping from thousands of stores and let us handle the delivery to your doorstep in Maldives!
               </p>
               <a
                  href="/signup"
                  className="inline-block bg-brand-600 hover:bg-brand-700 text-white font-bold py-4 px-10 rounded-lg shadow-lg text-lg transition focus:outline-none focus:ring-2 focus:ring-brand-400"
               >
                  Create Account &amp; Get Address
               </a>
               <p className="text-xs text-slate-400 mt-6">
                  No credit card required. Fast, secure, and trusted by thousands of Sri Lankan shoppers.
               </p>
            </RevealOnScroll>
         </div>
      </section>
   );
};

export default FinalCTA;